<template>
    <sections>
        <section-helpdesk heading="Contact" content="<article-contact />"></section-helpdesk>
    </sections>
</template>

<script setup>
const $config = useRuntimeConfig();
useSeo().buildHead({
    title: 'Contact | ' + $config.public.siteName,
    description: 'Send us a message with the following form.',
    index: true,
});
</script>
